import { render, staticRenderFns } from "./flexibleBox.vue?vue&type=template&id=599f528b&"
import script from "./flexibleBox.vue?vue&type=script&lang=js&"
export * from "./flexibleBox.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

component.options.__file = "pc/bhc/layout/flexibleBox.vue"
export default component.exports